module.exports = __webpack_public_path__ + "static/logo-be81746469801ab74f08b56782df1980.svg";